import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { Button, DefaultLayout, Input, LoadingOverlay, Text } from '@pletly/ui';
import { RootStackScreenProps } from '../../../../navigation/types';
import { useCreateTerms } from './components/useCreateTerms';
import { withTranslation } from '../../../../locales/hoc';

type Props = RootStackScreenProps<'NewTermsOfUse'>;

export const NewTermsOfUsePage = withTranslation(
	({
		route: {
			params: { uuid },
		},
	}: Props) => {
		const { t } = useTranslation();
		const { currentTermsLoading, canSave, handleSave, termsInput } = useCreateTerms({
			organisationUuid: uuid,
		});

		if (currentTermsLoading) return <LoadingOverlay show />;

		return (
			<DefaultLayout view>
				<View style={styles.header}>
					<Text category="h1">{t('terms-of-use.new-terms-of-use')}</Text>

					<Button
						color="primary"
						variant="filled"
						size="small"
						disabled={!canSave}
						onPress={handleSave}
					>
						{t('common.save')}
					</Button>
				</View>
				<Input
					multiline
					fullWidth
					numberOfLines={20}
					placeholder={t('terms-of-use.new-terms-of-use-field-placeholder')}
					{...termsInput}
				/>
			</DefaultLayout>
		);
	},
);

const styles = StyleSheet.create({
	header: {
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
});
